export var RICH_INLINE_NODE = 'rich_inline';
export var SELECTED_NODE = 'selected';
export var ERROR_NODE = 'error';